module.exports = __webpack_public_path__ + "static/media/meta-global-tech.6b1e4439.svg";